// Livre blanc — util partagé (chemin PDF hébergé + mention de consentement + téléchargement)
export const WHITEPAPER_PDF = "/livre-blanc-asap-reqen.pdf";
export const WHITEPAPER_TITLE = "Agile\u2026 mais toujours lent ?";
export const WHITEPAPER_SUBTITLE =
  "Pourquoi votre organisation n'accélère-t-elle pas ? 5 blocages invisibles qui freinent la performance.";

export const CONSENT_TEXT =
  "En renseignant ce formulaire, vous acceptez que vos données soient utilisées pour traiter votre demande. ASAP Technologies pourra également vous contacter au sujet de contenus et offres professionnels en lien avec votre activité. Vous pouvez vous y opposer à tout moment. En savoir plus dans notre Politique de confidentialité.";

export function downloadWhitepaper() {
  const a = document.createElement("a");
  a.href = WHITEPAPER_PDF;
  a.download = "Livre-Blanc-ASAP-Reqen-Agile-mais-toujours-lent.pdf";
  document.body.appendChild(a);
  a.click();
  a.remove();
}
